import { render, staticRenderFns } from "./MewtwoChallengeDialog.vue?vue&type=template&id=a4a3cf98&scoped=true"
import script from "./MewtwoChallengeDialog.vue?vue&type=script&lang=js"
export * from "./MewtwoChallengeDialog.vue?vue&type=script&lang=js"
import style0 from "./MewtwoChallengeDialog.vue?vue&type=style&index=0&id=a4a3cf98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4a3cf98",
  null
  
)

export default component.exports